import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TroubleshootIcon(props: IconProps) {
    return <Icon {...props} iconKey={"troubleshoot"}/>
}
